@if (showIcon == true) {
    <rr-icon name="info" class="w24" tone="nutral"></rr-icon>
}
@if (type == "DATA") {
    <div class="tiny">
        We don’t store your files. Data is processed securely under EU GDPR.
        <span class="strong"
            >Please avoid uploading personal or confidential information.</span
        >
        <br />
        <br />
        For more information, see our
        <a
            target="_blank"
            rel="noopener noreferrer"
            href="/docs/{{ legalToCs }}"
            >Terms and Conditions</a
        >
        ,
        <a target="_blank" rel="noopener noreferrer" href="/docs/{{ legalToU }}"
            >Terms of Use</a
        >
        and have read the
        <a
            target="_blank"
            rel="noopener noreferrer"
            href="/docs/{{ legalPrivacyPolicy }}"
            >Privacy Policy</a
        >.
    </div>
}
@if (type == "PAY_FOR_CHOISE") {
    By choosing one option, credits will be deducted from your balance right
    away.
}
@if (type == "USE_RIGHT_DATA") {
    <div class="tiny">
        Please make sure you use the right data in this case.
    </div>
}
@if (type === "EXTERNAL_RISK") {
    <div class="tiny">
        Results are fetched from external online sources. Accuracy,
        completeness, or relevance cannot be guaranteed.
    </div>
}
@if (type === "TERMS_CONDITIONS") {
    <div class="tiny">
        By logging in or registering, you agree to our
        <a
            target="_blank"
            rel="noopener noreferrer"
            href="/docs/{{ legalToCs }}"
            >Terms and Conditions</a
        >
        ,
        <a target="_blank" rel="noopener noreferrer" href="/docs/{{ legalToU }}"
            >Terms of Use</a
        >
        and have read the
        <a
            target="_blank"
            rel="noopener noreferrer"
            href="/docs/{{ legalPrivacyPolicy }}"
            >Privacy Policy</a
        >.
    </div>
}
@if (type === "PAGE_FOOTER") {
    <div
        class="w100 row gap-16 align-center justify-center padding-24 page-footer tiny"
    >
        <a
            target="_blank"
            rel="noopener noreferrer"
            href="/docs/{{ legalToCs }}"
            >Terms and Conditions</a
        >
        |
        <a target="_blank" rel="noopener noreferrer" href="/docs/{{ legalToU }}"
            >Terms of Use</a
        >
        |
        <a
            target="_blank"
            rel="noopener noreferrer"
            href="/docs/{{ legalPrivacyPolicy }}"
            >Privacy Policy</a
        >
        |
        <a target="_blank" rel="noopener noreferrer" href="/{{ legalImprint }}"
            >Imprint</a
        >
    </div>
}
